











































import SelfStationDataGetter from '@/service/SelfStationDataGetter';
import moment from 'moment/moment'
export default {
  props: {
    stationId: { type: String }
  },
  data() {
    return {
      screenWidth: 0,
      datetime: '',
      stationData: {
        datetime: ''
      }
    }
  },
  watch: {
    stationId() {
      // @ts-ignore
      this.stationData = { datetime: '' }
      // @ts-ignore
      this.getStationData()
    },
  },
  methods: {
    getStationData() {
      // @ts-ignore
      SelfStationDataGetter.getSelfStationData('surf_hour_data', 'station_id_c,datetime,tem,rhu,lst,irr,irr_max', this.stationId, '', '').then((res: any) => {
        if (res && res.length > 0) {
          // @ts-ignore
          this.stationData = res[0]
        }
      })
    }
  },
  filters: {
    dtFormat(timestamp: any) {
      if (timestamp) {
        const time = timestamp.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/g, '$1-$2-$3 $4:$5');

        return time
      }
    },
  },
}
